import { get, post } from './https';

export interface TonnageBreakdownItem {
  label: string;
  btu: number;
}

export interface TonnageResult {
  areaSqFt: number;
  totalBtu: number;
  exactTons: number;
  recommendedTonnage: number;
  units: number;
  recommendation: string;
  breakdown: TonnageBreakdownItem[];
}

export interface TonnagePayload {
  areaSqFt?: number;
  roomLengthFt?: number;
  roomWidthFt?: number;
  ceilingHeightFt?: number;
  occupants?: number;
  sunExposure?: 'LOW' | 'MEDIUM' | 'HIGH';
  isTopFloor?: boolean;
  hasKitchen?: boolean;
  windows?: number;
}

const CalculateTonnage = async (
  payload: TonnagePayload,
): Promise<TonnageResult> => {
  const response = await post('/api/v1/utility/tonnage/calculate', payload);
  if (response?.status === 200 && response?.data?.status) {
    return response.data.data;
  }
  throw new Error(response?.data?.message || 'Failed to calculate tonnage');
};

const GETTonnageConfig = async () => {
  const response = await get('/api/v1/utility/tonnage/config');
  if (response?.status === 200 && response?.data?.status) {
    return response.data.data;
  }
  throw new Error('Failed to load tonnage config');
};

export { CalculateTonnage, GETTonnageConfig };
